<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
	<rect width="48" height="48" rx="24" fill="#F9F2FF" />
	<g clip-path="url(#clip0_6981_16689)">
		<path
			d="M32.9626 26.7787H24.8203V21.6174H38.987C39.1235 22.5246 39.1883 23.4479 39.1883 24.3686C39.1883 29.0377 37.5486 32.9606 34.7232 35.6386H30.2644V32.4038C31.9438 31.2069 33.088 29.3992 33.4547 27.3675L33.5609 26.7787H32.9626Z"
			stroke="#8F00FF"
		/>
		<path
			d="M29.7445 32.7534L34.1424 36.1634C31.6348 38.2757 28.2836 39.5012 24.3205 39.5012C18.499 39.5012 13.1723 36.2419 10.5225 31.0688V27.5671H14.9901C16.4165 31.368 20.0471 34.1694 24.3263 34.1694C26.4217 34.1694 28.2644 33.6676 29.7445 32.7534Z"
			fill="#F9F2FF"
			stroke="#8F00FF"
		/>
		<path
			d="M14.837 17.3198V20.8601C14.1954 22.8155 14.168 24.9179 14.7549 26.8858L10.2061 30.4132C8.31663 26.2488 8.35934 21.4558 10.3342 17.3198H14.837Z"
			fill="#F9F2FF"
			stroke="#8F00FF"
		/>
		<path
			d="M24.3205 8.50108V8.50111L24.3264 8.50104C27.9989 8.45758 31.552 9.77361 34.3016 12.1811L30.4408 16.0419C28.741 14.5855 26.5637 13.7991 24.3166 13.8329C20.1572 13.8345 16.6052 16.483 15.106 20.129L10.6582 16.68C13.3513 11.6518 18.5968 8.50108 24.3205 8.50108Z"
			fill="#F9F2FF"
			stroke="#8F00FF"
		/>
	</g>
	<defs>
		<clipPath id="clip0_6981_16689">
			<rect width="32" height="32" fill="white" transform="translate(8 8)" />
		</clipPath>
	</defs>
</svg>
